import JsBarcode from "jsbarcode";

export function generateUniqueCode(): string {
  const letters = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  
  // Generate AAA999AAA format
  let code = '';
  
  // First AAA
  for (let i = 0; i < 2; i++) {
    code += letters[Math.floor(Math.random() * letters.length)];
  }
  
  // 999
  for (let i = 0; i < 2; i++) {
    code += numbers[Math.floor(Math.random() * numbers.length)];
  }
  
  // Add timestamp suffix to ensure uniqueness
  const timestamp = Date.now().toString(36);
  return code + timestamp.slice(-3); // Last 3 characters of timestamp for uniqueness
}

export function createBarcode(newCode: string) {
  const canvas = document.createElement("canvas");
  JsBarcode(canvas, newCode, {
    format: "CODE128",
    width: 2,
    height: 80,
    displayValue: true,
    fontSize: 18,
  });
  return canvas.toDataURL("image/png");
}
